export default {
  API_ENDPOINT: 'https://endless-encounters-v-tiff.herokuapp.com/api',
  TOKEN_KEY: 'auth-token'
}
